import React from 'react';

import './_footer.scss';

import Theodore from './assets/Theodore.png';

const Footer = () => (
  <footer id="footer">
    <img id="theodore" src={Theodore} alt="" />
    <div className="content">
      <div className="copyright">
        <h6>&copy; 2017 StarKiss Studios</h6>
      </div>
      <div className="signature">
        <h6>Handmade in Halifax, NS</h6>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js